import React from 'react';
import {
  ExclamationTriangleIcon
} from '@radix-ui/react-icons';


const ErrorPage = (): React.ReactElement => {
  return (
    <div className="h-full flex flex-col items-center justify-center bg-white">
      <ExclamationTriangleIcon width={48} height={48} className="pb-3" />
      <p className="pb-3">Nastala neočekávaná chyba. Kontaktujte, prosím, podporu.</p>
      <p>An unexpected error has occurred. Please contact support.</p>
    </div>
  )
}

export default ErrorPage;
